<template>
              <div>
              <div class="login-form find-a-provider">
                    <p class="h4">FIND A PROVIDER</p>
                       
                       <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Provider Name</label>
                            <div class="col-sm-10">
                              <input autocomplete="off" v-b-modal.modal-center v-model="ProviderNameA" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" required>
                            </div>
                          
                 
                        <div>
                        

                        <b-modal id="modal-scrollable" ref="search-modal" scrollable title="List of Providers:">
                            <div>
                            <a v-if="Providers.length == 0" style="font-size:30px;">Please enter a Provider Name.</a>
                            <a v-else-if="Providers.length > 0" class="my-4 doctor-list" v-for="item in Providers" :key="item.ProviderCode" @click="handleSelectItem(item)" > 
                              {{item.ProviderName}}<br>
                            
                            </a>
                            </div>
                        </b-modal>

                        <b-modal @shown="focusFirstInput" id="modal-center" ref="name-modal" content-class="customer-adv-modal" centered title="">
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">City</label>
                            <div class="col-sm-10">
                              <input ref="firstInput" autocomplete="off" v-model="City" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" @focus="show" data-layout="normal" required>
                            </div>
                            </div>
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Provider Name</label>
                            <div class="col-sm-10">
                              <input  autocomplete="off" v-model="ProviderName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" @focus="show" data-layout="normal" required>
                            </div>
                           </div>            
                           <b-button @click="FindProvider" v-b-modal.modal-scrollable type="button" class="search-btn">Search</b-button>
                      </b-modal>
                        </div>
                       </div>
                       </div>
                       <div class="row find-a-provider-action">
                        <router-link to="/member-page"><button class="btn btn-primary btn-lg">BACK</button></router-link>
                       <button type="submit" class="btn btn-primary btn-lg" v-on:click="updateProvider" :disabled="isDisable(this.ProviderNameA)">NEXT</button>
                       </div>
                       <div class="providerkeyboard">
                        
                      </div>
                      </div>  

 
         
  </template>
  
  
  <script>
  import axios from 'axios';
  export default {
    name: 'FindaProvider',
    data() {
      return {
        certNo: '',
        TokenID: '',
        City: '',
        ProviderName: '',
        ProviderNameA: '',
        ProviderCodeA: '',
        Providers: [],
        visible: false,
      layout: "normal",
      input: null,
      options: {
      useKbEvents: false,
      preventClickEvent: false,
      ProviderCode : ''
    }
      
      }
    },
    methods: {
      async FindProvider() {
        this.TokenID = localStorage.getItem('TokenID')
        this.certNo = localStorage.getItem('CertNo')
          const response = await axios.post('/api/?action=find-a-hospital', {
             CertNo: this.certNo,
             TokenID: this.TokenID,
             City: this.City,
             ProviderName: this.ProviderName
          }, 
          );
  
         
          var response_data = response.data.filter((dataf) => { 
            if (dataf.Access == 'WITH ACCESS') {
               return dataf
            } 

          });

          console.log('DATA', response_data);

          this.Providers=response_data
          this.showModal()
          
          
      },
      handleSelectItem(item){
      console.log(item);
      this.ProviderNameA = item.ProviderName
      this.ProviderCodeA = item.ProviderCode
      this.hideModal()
    },
    hideModal() {
            this.$refs['search-modal'].hide(),
            this.$refs['name-modal'].hide()
          },
    showModal() {
            this.$refs['search-modal'].show()
          },
      show(e) {

        console.log('e', e)
        this.input = e.target;
        this.layout = e.target.dataset.layout;
        
        if (!this.visible)
          this.visible = true
         
      },

      accept() {
          this.hide();
        },

      hide() { 
        console.log('sada');
        this.visible = false;
        console.log(document.querySelector(":focus"));
      },

      updateProvider: function() {
        this.$emit('providercode', this.ProviderCodeA)
        this.$emit('providername', this.ProviderNameA)
      },

      isDisable(provider) {
        return provider.length == 0;
      },
      focusFirstInput() {
      this.$refs.firstInput.focus();
      }
      
    },
    
    }
  
  
  
  </script>
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  